import { AttachIcon } from 'components/AttachIcon/AttachIcon';
import { ReactElement } from 'react';
import {
  DragDropFilePickerContent,
  DragDropFilePickerContentText,
  StyledDropzone,
} from './DragDropFilePicker-style';
import { IDragDropFilePickerProps } from './DragDropFilePicker-type';

export const DragDropFilePicker = (
  props: IDragDropFilePickerProps
): ReactElement => {
  const { iconType, contentText, ...restProps } = props;

  return (
    <StyledDropzone {...restProps}>
      <DragDropFilePickerContent>
        <AttachIcon type={iconType} />
        {contentText ? (
          <DragDropFilePickerContentText>
            {contentText}
          </DragDropFilePickerContentText>
        ) : null}
      </DragDropFilePickerContent>
    </StyledDropzone>
  );
};
